import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'sheba-search-icon',
  templateUrl: 'search.svg',
  host: {
    class: 'contents'
  },
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchIcon { }
